import { render } from "./TeacherMaster.vue?vue&type=template&id=ab406d90&scoped=true"
import script from "./TeacherMaster.vue?vue&type=script&lang=js"
export * from "./TeacherMaster.vue?vue&type=script&lang=js"

import "./TeacherMaster.vue?vue&type=style&index=0&id=ab406d90&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab406d90"]])

export default __exports__